let baseURL = "https://yakihonne.s3.ap-east-1.amazonaws.com/media/icons-mono";
const iconsUrls = {
  "add-curation": `${baseURL}/add-curation.svg`,
  "add-note": `${baseURL}/add-note.svg`,
  admin: `${baseURL}/admin.svg`,
  "ai-loader": `${baseURL}/ai_loading.gif`,
  "alby-logo": `${baseURL}/alby-logo.svg`,
  apple: `${baseURL}/apple.svg`,
  arrow: `${baseURL}/arrow.svg`,
  "arrow-up": `${baseURL}/arrow-up.svg`,
  "arrow-up-bold": `${baseURL}/arrow-up-bold.svg`,
  bold: `${baseURL}/bold.svg`,
  bolt: `${baseURL}/bolt.svg`,
  "bolt-bold": `${baseURL}/bolt-bold-c1.svg`,
  bookmark: `${baseURL}/bookmark-add.svg`,
  "bookmark-24-b": `${baseURL}/bookmark-checked-2.svg`,
  "bookmark-b": `${baseURL}/bookmark-checked-2.svg`,
  "bookmark-i": `${baseURL}/save-bookmark.svg`,
  "bookmark-i-b": `${baseURL}/save-bookmark-b.svg`,
  "bookmark-i-bold": `${baseURL}/bookmark-i-bold.svg`,
  bounties: `${baseURL}/bounties.svg`,
  "broken-image": `${baseURL}/broken-image.svg`,
  "bronze-medal": `${baseURL}/bronze-medal.svg`,
  bug: `${baseURL}/bug.svg`,
  "bunny-icon": `${baseURL}/bunny-icon.svg`,
  "burger-menu": `${baseURL}/burger-menu.svg`,
  button: `${baseURL}/button.svg`,
  buzz: `${baseURL}/buzz.svg`,
  "buzz-bold": `${baseURL}/buzz-bold.svg`,
  cache: `${baseURL}/cache.svg`,
  calendar: `${baseURL}/calendar.svg`,
  cancel: `${baseURL}/cancel.svg`,
  categories: `${baseURL}/categories.svg`,
  check: `${baseURL}/check.svg`,
  checkmark: `${baseURL}/checkmark.svg`,
  "checkmark-c1": `${baseURL}/checkmark-c1.svg`,
  "checkmark-tt": `${baseURL}/checkmark-tt.svg`,
  clone: `${baseURL}/clone.svg`,
  code: `${baseURL}/code.svg`,
  comment: `${baseURL}/comment.svg`,
  "comment-icon": `${baseURL}/comment.svg`,
  "comment-not": `${baseURL}/comment-not.svg`,
  connect: `${baseURL}/connect.svg`,
  "container-one": `${baseURL}/container-one.svg`,
  "container-one-one": `${baseURL}/container-one-one.svg`,
  "container-one-two": `${baseURL}/container-one-two.svg`,
  "container-two-one": `${baseURL}/container-two-one.svg`,
  "content-s": `${baseURL}/content-s.svg`,
  copy: `${baseURL}/copy.svg`,
  "crossmark-tt": `${baseURL}/crossmark-tt.svg`,
  cup: `${baseURL}/cup.svg`,
  curation: `${baseURL}/curation.svg`,
  "curation-bold": `${baseURL}/curation-bold.svg`,
  "curation-plus": `${baseURL}/curation-plus.svg`,
  custom: `${baseURL}/custom.svg`,
  dashboard: `${baseURL}/dashboard.svg`,
  "dashboard-bold": `${baseURL}/dashboard-bold.svg`,
  "deposit-sats": `${baseURL}/deposit-sats.svg`,
  "discord-logo": `${baseURL}/discord-logo.svg`,
  discover: `${baseURL}/discover.svg`,
  "discover-bold": `${baseURL}/discover-bold.svg`,
  download: `${baseURL}/download.svg`,
  "download-file": `${baseURL}/download-file.svg`,
  edit: `${baseURL}/edit.svg`,
  emoji: `${baseURL}/emoji.svg`,
  env: `${baseURL}/env.svg`,
  "env-bold": `${baseURL}/env-bold.svg`,
  "env-edit": `${baseURL}/env-edit.svg`,
  export: `${baseURL}/export.svg`,
  "eye-closed": `${baseURL}/eye-closed.svg`,
  "eye-opened": `${baseURL}/eye-opened.svg`,
  "facebook-logo": `${baseURL}/facebook-logo.svg`,
  "failed-events": `${baseURL}/failed-events.svg`,
  "fb-icon": `${baseURL}/fb-icon.svg`,
  filter: `${baseURL}/filter.svg`,
  flag: `${baseURL}/flag.svg`,
  "flag-ar": `${baseURL}/flag-ar.svg`,
  "flag-en": `${baseURL}/flag-en.svg`,
  "flag-es": `${baseURL}/flag-es.svg`,
  "flag-fr": `${baseURL}/flag-fr.svg`,
  "flag-hi": `${baseURL}/flag-hi.svg`,
  "flag-it": `${baseURL}/flag-it.svg`,
  "flag-ja": `${baseURL}/flag-ja.svg`,
  "flag-pt": `${baseURL}/flag-pt.svg`,
  "flag-ru": `${baseURL}/flag-ru.svg`,
  "flag-th": `${baseURL}/flag-th.svg`,
  "flag-zh": `${baseURL}/flag-zh.svg`,
  folder: `${baseURL}/folder.svg`,
  "folder-bold": `${baseURL}/folder-bold.svg`,
  followings: `${baseURL}/followings.svg`,
  frames: `${baseURL}/frames.svg`,
  gift: `${baseURL}/gift.svg`,
  "github-logo": `${baseURL}/github-logo.svg`,
  globe: `${baseURL}/globe.svg`,
  "golden-medal": `${baseURL}/golden-medal.svg`,
  google: `${baseURL}/google.svg`,
  hashtag: `${baseURL}/hashtag.svg`,
  heart: `${baseURL}/heart.svg`,
  "heart-bold": `${baseURL}/heart-bold.svg`,
  home: `${baseURL}/home.svg`,
  "home-bold": `${baseURL}/home-bold.svg`,
  image: `${baseURL}/image.svg`,
  "in-icon": `${baseURL}/in-icon.svg`,
  infinity: `${baseURL}/infinity.svg`,
  info: `${baseURL}/info.svg`,
  "info-flag": `${baseURL}/info-flag.svg`,
  "info-tt": `${baseURL}/info-tt.svg`,
  "instagram-logo": `${baseURL}/instagram-logo.svg`,
  italic: `${baseURL}/italic.svg`,
  "keplr-icon": `${baseURL}/keplr-logo.svg`,
  "key-icon": `${baseURL}/keys.svg`,
  layers: `${baseURL}/layers.svg`,
  layout: `${baseURL}/layout.svg`,
  lightning: `${baseURL}/lightning.svg`,
  like: `${baseURL}/like.svg`,
  "like-bold": `${baseURL}/like-bold.svg`,
  link: `${baseURL}/link.svg`,
  logout: `${baseURL}/logout.svg`,
  "logout-red": `${baseURL}/logout-red.svg`,
  medal: `${baseURL}/medal.svg`,
  media: `${baseURL}/media.svg`,
  "media-bold": `${baseURL}/media-bold.svg`,
  menu: `${baseURL}/menu.svg`,
  "metamask-logo": `${baseURL}/metamask-logo.svg`,
  mobile: `${baseURL}/mobile.svg`,
  "msg-bubbles": `${baseURL}/msg-bubbles.svg`,
  "msg-icon": `${baseURL}/msg-icon.svg`,
  mute: `${baseURL}/mute.svg`,
  news: `${baseURL}/news.svg`,
  "news-bold": `${baseURL}/news-bold.svg`,
  "news-plus": `${baseURL}/news-plus.svg`,
  nip05: `${baseURL}/nip05.svg`,
  "nostr-icon": `${baseURL}/nostr-icon.svg`,
  note: `${baseURL}/note.svg`,
  "note-2": `${baseURL}/note-2.svg`,
  "note-2-bold": `${baseURL}/note-2-bold.svg`,
  "note-bold": `${baseURL}/note-bold.svg`,
  "note-plus": `${baseURL}/note-plus.svg`,
  "nut-zap": `${baseURL}/nut-zap.svg`,
  "nwc-logo": `${baseURL}/nwc-logo.svg`,
  orbit: `${baseURL}/relay-orbits-mono.svg`,
  "orbit-bold": `${baseURL}/relay-orbits-filled.svg`,
  pin: `${baseURL}/pin.svg`,
  plain: `${baseURL}/plain.svg`,
  play: `${baseURL}/play.svg`,
  "play-b": `${baseURL}/play-b.svg`,
  "play-bold": `${baseURL}/play-bold.svg`,
  "play-plus": `${baseURL}/play-plus.svg`,
  "play-vid": `${baseURL}/play-vid.svg`,
  "plus-sign": `${baseURL}/plus-sign.svg`,
  "plus-sign-w": `${baseURL}/plus-sign.svg`,
  podcast: `${baseURL}/podcast.svg`,
  polls: `${baseURL}/polls.svg`,
  posts: `${baseURL}/posts.svg`,
  "posts-bold": `${baseURL}/posts-bold.svg`,
  "posts-plus": `${baseURL}/posts-plus.svg`,
  protected: `${baseURL}/protected.svg`,
  "protected-2": `${baseURL}/secure-mono.svg`,
  "pub-hex": `${baseURL}/pub-hex.svg`,
  qrcode: `${baseURL}/qrcode.svg`,
  quote: `${baseURL}/quote.svg`,
  "quote-bold": `${baseURL}/quote-bold.svg`,
  "raw-event": `${baseURL}/raw-event.svg`,
  recent: `${baseURL}/recent-mono.svg`,
  "recent-wr": `${baseURL}/recent-with-replies-mono.svg`,
  "redeem-ecash": `${baseURL}/redeem-ecash.svg`,
  report: `${baseURL}/report.svg`,
  republish: `${baseURL}/republish-2-mono.svg`,
  restore: `${baseURL}/swap-mint-lightning.svg`,
  ringbell: `${baseURL}/ringbell.svg`,
  "ringbell-bold": `${baseURL}/ringbell-bold.svg`,
  sats: `${baseURL}/sats.svg`,
  search: `${baseURL}/search.svg`,
  send: `${baseURL}/send.svg`,
  "send-ecash": `${baseURL}/send-ecash.svg`,
  server: `${baseURL}/relay.svg`,
  setting: `${baseURL}/setting.svg`,
  "share-icon": `${baseURL}/share.svg`,
  "share-icon-2": `${baseURL}/share-icon-2.svg`,
  "share-v2": `${baseURL}/share-v2.svg`,
  "silver-medal": `${baseURL}/silver-medal.svg`,
  "smart-widget": `${baseURL}/smart-widget.svg`,
  "smart-widget-add": `${baseURL}/smart-widget.svg`,
  "smart-widget-bold": `${baseURL}/smart-widget-bold.svg`,
  "smart-widget-checker": `${baseURL}/smart-widget-checker.svg`,
  "smart-widget-draft": `${baseURL}/sw-draft.svg`,
  star: `${baseURL}/star.svg`,
  "star-bold": `${baseURL}/star-bold.svg`,
  "star-boldt": `${baseURL}/star-bold.svg`,
  stories: `${baseURL}/stories.svg`,
  "succeeded-events": `${baseURL}/succeeded-events.svg`,
  success: `${baseURL}/success.svg`,
  "switch-arrows": `${baseURL}/switch-arrows.svg`,
  "switch-arrows-bold": `${baseURL}/switch-arrows-bold.svg`,
  "switch-arrows-v2": `${baseURL}/switch-arrows-v2.svg`,
  "telegram-b-logo": `${baseURL}/telegram.svg`,
  "telegram-logo": `${baseURL}/telegram-logo.svg`,
  text: `${baseURL}/text.svg`,
  theme: `${baseURL}/theme.svg`,
  thumbsdown: `${baseURL}/thumbsdown.svg`,
  thumbsup: `${baseURL}/thumbsup.svg`,
  timeline: `${baseURL}/timeline.svg`,
  title: `${baseURL}/title.svg`,
  "total-events": `${baseURL}/total-events.svg`,
  translate: `${baseURL}/translate.svg`,
  trash: `${baseURL}/trash.svg`,
  "trending-up": `${baseURL}/trending-up.svg`,
  "twitter-logo": `${baseURL}/twitter-logo.svg`,
  "twitter-w-logo": `${baseURL}/twitter-logo.svg`,
  undo: `${baseURL}/undo.svg`,
  unmute: `${baseURL}/unmute.svg`,
  unpin: `${baseURL}/unpin.svg`,
  unprotected: `${baseURL}/unprotected.svg`,
  "upload-file": `${baseURL}/upload-file.svg`,
  user: `${baseURL}/user.svg`,
  "user-bold": `${baseURL}/user-bold.svg`,
  "user-followed": `${baseURL}/user-followed.svg`,
  "user-followed-w": `${baseURL}/user-followed.svg`,
  "user-to-follow": `${baseURL}/user-to-follow.svg`,
  "user-to-unfollow": `${baseURL}/user-to-unfollow.svg`,
  video: `${baseURL}/video.svg`,
  "video-pause": `${baseURL}/video-pause.svg`,
  "video-play": `${baseURL}/video-play.svg`,
  views: `${baseURL}/views.svg`,
  "volume-muted": `${baseURL}/volume-muted.svg`,
  "volume-normal": `${baseURL}/volume-normal.svg`,
  wallet: `${baseURL}/wallet.svg`,
  "wallet-add": `${baseURL}/wallet-add.svg`,
  "wallet-confirm": `${baseURL}/wallet-confirm.svg`,
  warning: `${baseURL}/warning.svg`,
  "webln-logo": `${baseURL}/webln-logo.svg`,
  "weechat-logo": `${baseURL}/weechat-logo.png`,
  "whatsapp-icon": `${baseURL}/whatsapp-icon.svg`,
  write: `${baseURL}/write.svg`,
  "yaki-logomark": `${baseURL}/yaki-logomark.svg`,
  "yakihonne-logo": `${baseURL}/yakihonne_logo.svg`,
  "youtube-logo": `${baseURL}/youtube.svg`,
  zapstore: `${baseURL}/Zapstore.svg`,
};

const getIcon = (name) => {
  return iconsUrls[name];
};

export { getIcon };
